export const AMC_REFERENCE_DATA = "allSureMotorClaim/referenceData/";
export const AMC_REFERENCE_DATA_SET_VALUE = AMC_REFERENCE_DATA+"setValue/";
export const setAmcReferenceDataValue =(value)=>({type: AMC_REFERENCE_DATA_SET_VALUE, value})


// Vehicle Reference Data
export const AMC_VEHICLE_MAKE_REFERENCE_DATA_SET_VALUE = AMC_REFERENCE_DATA+ "vehicleMakeReferenceData/setValue/";
export const AMC_VEHICLE_MODEL_REFERENCE_DATA_SET_VALUE = AMC_REFERENCE_DATA+"vehicleModelReferenceData/setValue/";

export const AMC_VEHICLE_MAKE_REFERENCE_DATA_GET_VALUE = AMC_REFERENCE_DATA+ "vehicleMakeReferenceData/getValue/";
export const AMC_VEHICLE_MODEL_REFERENCE_DATA_GET_VALUE = AMC_REFERENCE_DATA+"vehicleModelReferenceData/getValue/";


export const setVehicleMakeReferenceData = (value) => ({  
  type: AMC_VEHICLE_MAKE_REFERENCE_DATA_SET_VALUE,
  value
});
export const setVehicleModelReferenceData = (value) => ({
  type: AMC_VEHICLE_MODEL_REFERENCE_DATA_SET_VALUE,
  value
});

export const getVehicleMakeReferenceData = () => ({  
  type: AMC_VEHICLE_MAKE_REFERENCE_DATA_GET_VALUE,
});
export const getVehicleModelReferenceData = (value) => ({
  type: AMC_VEHICLE_MODEL_REFERENCE_DATA_GET_VALUE,
  value
});

export const AMC_APPLICATION_API_STATUS = AMC_REFERENCE_DATA + 'setApiStatus';
export const setAmcApplicationApiStatus = (value) => ({
    type: AMC_APPLICATION_API_STATUS,
    value
});
